import { useState, useCallback } from 'react';
import api from '../../../../../config/axiosConfig';

export function useStudentCardData(buildParams) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchData = useCallback(async () => {
        setLoading(true);
        setError(null);
        
        try {
            const params = buildParams();
            const response = await api.get('/operations/api/v1/student-registrations/student-card/', { params });
            setData(response.data);
            return response.data;
        } catch (err) {
            setError(err.message);
            throw err;
        } finally {
            setLoading(false);
        }
    }, [buildParams]);

    return {
        data,
        loading,
        error,
        fetchData
    };
}

